import { render } from "./ReservationDialog.vue?vue&type=template&id=1b45bf7a&scoped=true"
import script from "./ReservationDialog.vue?vue&type=script&lang=js"
export * from "./ReservationDialog.vue?vue&type=script&lang=js"

import "./ReservationDialog.vue?vue&type=style&index=0&id=1b45bf7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b45bf7a"]])

export default __exports__